import React from 'react';
import LandingWrapper from '@/components/Landing/LandingWrapper/LandingWrapper';
import ForgetPasswordForm from '@/components/Landing/Forms/ForgetPasswordForm/ForgetPasswordForm';

const ForgetPassword = () => {
  return <LandingWrapper Form={ForgetPasswordForm} />;
};

export default ForgetPassword;
